import { useEffect, useRef, useState } from "react";
import { fileUrl } from "@/lib/api";
import { MediaModal, ModalSpinner } from "@/components/catalog/MediaModal";

async function loadPdfJs() {
  const pdfjs = await import("pdfjs-dist/build/pdf.min.mjs");
  pdfjs.GlobalWorkerOptions.workerSrc = `${process.env.PUBLIC_URL || ""}/pdf.worker.min.js`;
  return pdfjs;
}

function PdfPages({ path }) {
  const box = useRef(null);
  const [state, setState] = useState("loading");

  useEffect(() => {
    let cancelled = false;
    let doc = null;
    (async () => {
      try {
        const pdfjs = await loadPdfJs();
        const res = await fetch(fileUrl(path));
        if (!res.ok) throw new Error("pdf");
        const data = new Uint8Array(await res.arrayBuffer());
        if (cancelled) return;
        doc = await pdfjs.getDocument({ data }).promise;
        if (cancelled) return;
        const width = box.current.clientWidth;
        const dpr = Math.min(window.devicePixelRatio || 1, 2) * 1.5;
        for (let n = 1; n <= doc.numPages; n += 1) {
          const page = await doc.getPage(n);
          if (cancelled) return;
          const base = page.getViewport({ scale: 1 });
          const vp = page.getViewport({ scale: (width / base.width) * dpr });
          const canvas = document.createElement("canvas");
          canvas.width = vp.width;
          canvas.height = vp.height;
          canvas.style.width = "100%";
          canvas.className = "mb-3 block bg-white shadow";
          canvas.setAttribute("data-testid", `pdf-page-${n}`);
          canvas.setAttribute("aria-label", `Página ${n} de ${doc.numPages}`);
          await page.render({ canvasContext: canvas.getContext("2d"), viewport: vp }).promise;
          if (cancelled) return;
          box.current.appendChild(canvas);
          if (n === 1) setState("ready");
        }
      } catch {
        if (!cancelled) setState("error");
      }
    })();
    return () => { cancelled = true; doc?.destroy(); };
  }, [path]);

  return (
    <div className="flex-1 overflow-y-auto overscroll-contain bg-[#E9ECEC] p-3 pt-14 md:p-5 md:pt-14" style={{ touchAction: "pan-x pan-y pinch-zoom" }} data-testid="pdf-scroll">
      {state === "loading" && <ModalSpinner label="Cargando ficha…" testId="pdf-loading" />}
      {state === "error" && <p className="py-16 text-center text-sm text-[#3E5641]" data-testid="pdf-error">No pudimos cargar la ficha. Inténtalo de nuevo.</p>}
      <div ref={box} className={state === "error" ? "hidden" : ""} onContextMenu={(e) => e.preventDefault()} />
    </div>
  );
}

export function PdfModal({ open, onClose, path, titulo }) {
  return (
    <MediaModal open={open} onClose={onClose} title={`Ficha técnica · ${titulo}`} testId="pdf-modal"
      contentClassName="h-[92vh] w-[96vw] max-w-4xl bg-white">
      <p className="absolute inset-x-0 top-0 z-10 bg-white/95 px-4 py-4 pr-14 mono text-[11px] uppercase tracking-widest text-[#A0553F] shadow-sm">Detalles del auto</p>
      {open && <PdfPages path={path} />}
    </MediaModal>
  );
}
